(() => {
  // A native Shopify form handles cart submission, including when JS is disabled.
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-course-variant]')) return;
    const option = event.target.selectedOptions[0];
    const form = event.target.closest('form');
    const available = option.dataset.available === 'true';
    form.querySelector('[data-course-price]').textContent = option.dataset.price;
    form.querySelector('[data-course-quantity]').value = option.dataset.quantity;
    form.querySelector('[name="add"]').disabled = !available;
    form.querySelector('[data-course-buy-label]').textContent = available ? 'Dodaj do koszyka' : 'Obecnie niedostępny';
  });
})();
